var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "m-5 md:m-15 2xl:m-20"
  }, [_c('EvalInProgress', {
    attrs: {
      "evaluation-in-progress": _vm.evaluationInProgress
    },
    on: {
      "massAssignation": function ($event) {
        return _vm.displayAssignTemplate();
      },
      "showPreview": function ($event) {
        _vm.showPreview = true;
      }
    }
  }), _vm._v(" "), _c('mass-template-assignation', {
    attrs: {
      "opened": _vm.massAssignation,
      "template": _vm.massAssignationTemplate
    },
    on: {
      "close": function ($event) {
        _vm.massAssignation = false;
      }
    }
  }), _vm._v(" "), _c('deactivate-template-popup', {
    attrs: {
      "confirm-deactivate-template": _vm.confirmDeactivateTemplate,
      "template-name-to-deactivate": _vm.templateNameToDeactivate,
      "list-assigned-users-template": _vm.listAssignedUsersTemplate,
      "template-page-to-assign-after-delete": _vm.templatePageToAssignAfterDelete
    },
    on: {
      "confirm_deactivate_template": function (templatePageToAssignAfterDelete) {
        _vm.confirm_deactivate_template(templatePageToAssignAfterDelete);
      },
      "close": function ($event) {
        _vm.confirmDeactivateTemplate = -1;
      }
    }
  }), _vm._v(" "), _c('activate-template-popup', {
    attrs: {
      "confirm-activate-template": _vm.confirmActivateTemplate,
      "template-name-to-deactivate": _vm.templateNameToDeactivate
    },
    on: {
      "confirm_activate_template": function ($event) {
        return _vm.confirm_activate_template();
      },
      "close": function ($event) {
        _vm.confirmActivateTemplate = -1;
      }
    }
  }), _vm._v(" "), _c('popup', {
    attrs: {
      "opened": _vm.showPreview
    },
    on: {
      "close": function ($event) {
        _vm.showPreview = false;
      }
    }
  }, [_c('div', [_c('h3', {
    staticClass: "my-10 w-full"
  }, [_vm._v("\n        " + _vm._s(_vm.infosPage.libelle_template) + "\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', {
    staticClass: "mx-15 2xl:mx-20 mb-10 text-gray-600"
  }, [_vm._v("\n        Cette page est un apercu interactif, vous pouvez modifier les valeurs\n        des champs sans que cela ne se répercute sur le modèle de page\n      ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "w-max-content w-max cursor-pointer flex items-center mx-15 2xl:mx-20 mb-5"
  }, [_c('span', {
    staticClass: "plus-button 2xl:h-10 2xl:w-10"
  }, [_c('icon', {
    attrs: {
      "name": "plus"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-base text-gray-600 ml-4 flex-initial"
  }, [_c('div', [_vm._v("Ajouter une langue")]), _vm._v(" "), _c('div', {
    staticClass: "text-sm font-light"
  }, [_vm._v("(Bouton non fonctionnel)")])])]), _vm._v(" "), _c('div', {
    staticClass: "w-max-content w-max text-lg text-gray-600 h-16 lg:h-24 2xl:h-32 font-normal grid grid-cols-12 gap-x-4 place-content-center mt-5"
  }, [_c('div', {
    staticClass: "col-start-2 lg:col-start-2 col-span-6 lg:col-span-2"
  }, [_vm._v("\n            Langue\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden lg:inline-block col-span-2"
  }, [_vm._v("\n            Comprendre\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden lg:inline-block col-span-4"
  }, [_vm._v("\n            Parler\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden lg:inline-block col-span-2"
  }, [_vm._v("\n            Ecrire\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-5 lg:col-span-1 -ml-5"
  }, [_vm._v("\n            Global\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "odd:bg-indigo-100 odd:bg-opacity-50"
  }, [_c('div', {
    staticClass: "h-16 lg:h-24 2xl:h-32 hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center cursor-pointer",
    class: {
      'bg-indigo-200 border-l-2 border-indigo-600': _vm.langueDisplayed == 0
    },
    on: {
      "click": function ($event) {
        return _vm.displayLangue(0);
      }
    }
  }, [_c('icon', {
    staticClass: "text-pink-600 col-span-1 place-self-center transform transition-transform ease-in-out duration-300",
    class: {
      'rotate-90': _vm.langueDisplayed == 0
    },
    attrs: {
      "name": "chevron-right"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 lg:col-span-2 text-base text-indigo-600 font-normal flex items-center overflow-y-hidden"
  }, [_vm._v("\n              Anglais\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden lg:inline-block col-span-2 text-base font-normal place-self-center justify-self-start"
  }, [_c('div', [_vm._v("Ecouter : "), _c('span', {
    staticClass: "text-pink-600"
  }, [_vm._v("A1")])]), _vm._v(" "), _c('div', [_vm._v("Lire : "), _c('span', {
    staticClass: "text-pink-600"
  }, [_vm._v("A1")])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden lg:inline-block col-span-4 text-base font-normal place-self-center justify-self-start"
  }, [_c('div', [_vm._v("\n                Prendre part à une conversation :\n                "), _c('span', {
    staticClass: "text-pink-600"
  }, [_vm._v("A2")])]), _vm._v(" "), _c('div', [_vm._v("\n                S’exprimer oralement en continu :\n                "), _c('span', {
    staticClass: "text-pink-600"
  }, [_vm._v("B1")])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden lg:inline-block col-span-2 text-base font-normal place-self-center justify-self-start"
  }, [_c('div', [_vm._v("Ecrire : "), _c('span', {
    staticClass: "text-pink-600"
  }, [_vm._v("A1")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-5 lg:col-span-1 text-base text-indigo-600 font-normal place-self-center mr-15 2xl:mr-20"
  }, [_vm._v("\n              A2\n            ")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_vm.langueDisplayed == 0 ? _c('div', {
    staticClass: "bg-white p-5 md:p-15 grid grid-cols-12 gap-x-4 gap-y-10"
  }, [_vm._l(_vm.templateContent, function (field, jndex) {
    return _c('div', {
      key: jndex,
      staticClass: "col-span-full lg:col-span-6 flex",
      class: {
        'lg:col-start-1': jndex == 1
      }
    }, [field.type == 'text' && jndex == 0 ? _c('input-text', {
      attrs: {
        "libelle": field.libelle,
        "value": "Anglais"
      }
    }) : field.type == 'multi' ? _c('input-select', {
      attrs: {
        "name": field.libelle.toLowerCase().replace(' ', '_').replace('\'', '') + _vm.indexLangue,
        "libelle": field.libelle,
        "datas": [{
          value: 'A1'
        }, {
          value: 'A2'
        }, {
          value: 'B1'
        }, {
          value: 'B2'
        }, {
          value: 'C1'
        }, {
          value: 'C2'
        }, {
          value: 'D1'
        }, {
          value: 'D2'
        }]
      }
    }) : _vm._e()], 1);
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full lg:col-start-1 lg:col-span-3 w-max-content w-max cursor-pointer flex text-gray-600 items-center"
  }, [_c('span', {
    staticClass: "minus-button 2xl:h-10 2xl:w-10 2xl:mt-2"
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-base ml-3"
  }, [_c('div', [_vm._v("Supprimer cette langue")]), _vm._v(" "), _c('div', {
    staticClass: "text-sm font-light"
  }, [_vm._v("\n                    (Bouton non fonctionnel)\n                  ")])])])], 2) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "odd:bg-indigo-100 odd:bg-opacity-50"
  }, [_c('div', {
    staticClass: "h-16 lg:h-24 2xl:h-32 hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center cursor-pointer",
    class: {
      'bg-indigo-200 border-l-2 border-indigo-600': _vm.langueDisplayed == 0
    },
    on: {
      "click": function ($event) {
        return _vm.displayLangue(0);
      }
    }
  }, [_c('icon', {
    staticClass: "text-pink-600 col-span-1 place-self-center transform transition-transform ease-in-out duration-300",
    class: {
      'rotate-90': _vm.langueDisplayed == 0
    },
    attrs: {
      "name": "chevron-right"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 lg:col-span-2 text-base text-indigo-600 font-normal flex items-center overflow-y-hidden"
  }, [_vm._v("\n              Espagnol\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden lg:inline-block col-span-2 text-base font-normal place-self-center justify-self-start"
  }, [_c('div', [_vm._v("Ecouter : "), _c('span', {
    staticClass: "text-pink-600"
  }, [_vm._v("A1")])]), _vm._v(" "), _c('div', [_vm._v("Lire : "), _c('span', {
    staticClass: "text-pink-600"
  }, [_vm._v("C2")])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden lg:inline-block col-span-4 text-base font-normal place-self-center justify-self-start"
  }, [_c('div', [_vm._v("\n                Prendre part à une conversation :\n                "), _c('span', {
    staticClass: "text-pink-600"
  }, [_vm._v("C2")])]), _vm._v(" "), _c('div', [_vm._v("\n                S’exprimer oralement en continu :\n                "), _c('span', {
    staticClass: "text-pink-600"
  }, [_vm._v("D1")])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden lg:inline-block col-span-2 text-base font-normal place-self-center justify-self-start"
  }, [_c('div', [_vm._v("Ecrire : "), _c('span', {
    staticClass: "text-pink-600"
  }, [_vm._v("A2")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-5 lg:col-span-1 text-base text-indigo-600 font-normal place-self-center mr-15 2xl:mr-20"
  }, [_vm._v("\n              B2\n            ")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_vm.langueDisplayed == 0 ? _c('div', {
    staticClass: "bg-white p-5 md:p-15 grid grid-cols-12 gap-x-4 gap-y-10"
  }, [_vm._l(_vm.templateContent, function (field, jndex) {
    return _c('div', {
      key: jndex,
      staticClass: "col-span-full lg:col-span-6 flex",
      class: {
        'lg:col-start-1': jndex == 1
      }
    }, [field.type == 'text' && jndex == 0 ? _c('input-text', {
      attrs: {
        "libelle": field.libelle,
        "value": "Espagnol"
      }
    }) : field.type == 'multi' ? _c('input-select', {
      attrs: {
        "name": field.libelle.toLowerCase().replace(' ', '_').replace('\'', '') + _vm.indexLangue,
        "libelle": field.libelle,
        "datas": [{
          value: 'A1'
        }, {
          value: 'A2'
        }, {
          value: 'B1'
        }, {
          value: 'B2'
        }, {
          value: 'C1'
        }, {
          value: 'C2'
        }, {
          value: 'D1'
        }, {
          value: 'D2'
        }]
      }
    }) : _vm._e()], 1);
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full lg:col-start-1 lg:col-span-3 w-max-content w-max cursor-pointer flex text-gray-600 items-center"
  }, [_c('span', {
    staticClass: "minus-button 2xl:h-10 2xl:w-10 2xl:mt-2"
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-base ml-3"
  }, [_c('div', [_vm._v("Supprimer cette langue")]), _vm._v(" "), _c('div', {
    staticClass: "text-sm font-light"
  }, [_vm._v("\n                    (Bouton non fonctionnel)\n                  ")])])])], 2) : _vm._e()])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5 md:mb-15 2xl:mb-20"
  }, [_c('h3', [_vm._v("\n      " + _vm._s(this.infosPage.libelle_template) + "\n    ")])]), _vm._v(" "), _c('list-buttons', {
    attrs: {
      "evaluation-in-progress": _vm.evaluationInProgress,
      "is-active": _vm.infosPage.is_active,
      "can-delete": false
    },
    on: {
      "preview": function () {
        _vm.showPreview = true;
      },
      "deactivateTemplate": function ($event) {
        return _vm.displayConfirmDeactivateTemplate();
      },
      "activateTemplate": function ($event) {
        return _vm.displayConfirmActivateTemplate();
      },
      "assignTemplate": function ($event) {
        return _vm.displayAssignTemplate();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mx-15"
  }, [_c('h3', {
    staticClass: "text-lg text-gray-600"
  }, [_vm._v("\n      Le référentiel Européen des langues n'est pas modifiable."), _c('br'), _vm._v("\n      Vous pouvez simplement\n      "), _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_DESACTIVER) ? _c('span', [_vm._v("activer ou désactiver")]) : _c('span', [_vm._v("visualiser")]), _vm._v(" le modèle de page.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "my-15 flex justify-center"
  }, [_c('illustration', {
    attrs: {
      "name": "notAllowed"
    }
  })], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }